"use client";
import Image from "next/image";
import EnrollTourButtons from "@/components/cms/EnrollTourButtons";
import { motion } from "framer-motion";

const DEFAULT_ACTIVITIES: { src: string; alt: string }[] = [];

export default function Culture({ cms }: { cms?: Record<string, string> }) {
  let cultureActivities: { src: string; alt: string }[] = DEFAULT_ACTIVITIES;
  try {
    if (cms?.activities) cultureActivities = JSON.parse(cms.activities);
  } catch {
    // use default
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <motion.h2
          className="text-4xl sm:text-5xl md:text-6xl font-bold text-school-navy mb-8"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, margin: "-100px 0px -100px 0px" }}
          transition={{ type: "spring", stiffness: 120, damping: 20 }}
        >
          {cms?.heading /* || "Our Culture" */}
        </motion.h2>
        <div className="text-lg sm:text-xl md:text-2xl text-school-navy space-y-6 mb-14 max-w-4xl leading-relaxed font-light">
          <p>
            {cms?.description /* || "Cultural activities help to enhance the confidence levels of the students allowing them to perform better. These activities develop the personality of the students and assist them in shaping a good career." */}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mb-12">
          {cultureActivities.map((activity, idx) => (
            <div key={idx} className="text-center flex flex-col items-center">
              <div className="w-20 sm:w-25 md:w-30 lg:w-35 aspect-square relative mb-4">
                <Image
                  src={activity.src}
                  alt={activity.alt}
                  fill
                  className="object-contain filter brightness-0"
                  sizes="(max-width: 639px) 80px, (max-width: 767px) 100px, (max-width: 1023px) 120px, 140px"
                />
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900">
                {activity.alt}
              </h3>
            </div>
          ))}
        </div>
        <EnrollTourButtons
          className="flex flex-col sm:flex-row gap-4 justify-center"
          buttonClassName="bg-school-gold hover:bg-school-gold-dark text-black font-bold py-4 px-8 rounded text-lg transition-colors text-center"
          enrollText={cms?.enrol_btn_text /* || "ENROL NOW" */}
          tourText={cms?.tour_btn_text /* || "BOOK A TOUR" */}
          enrollUrl={cms?.enrol_btn_url}
          tourUrl={cms?.tour_btn_url}
        />
      </div>
    </section>
  );
}
